<template>
  <div class="geoproceso-opciones-generales">
    <fieldset>
      <legend>Capas a utilizar en el análisis:</legend>
      <label>
        <input
          type="radio"
          value="todas"
          :checked="capas === 'todas'"
          @change="$emit('update:capas', 'todas')"
        />
        Usar todas las capas [por defecto]
      </label>
      <label>
        <input
          type="radio"
          value="cargadas"
          :checked="capas === 'cargadas'"
          @change="$emit('update:capas', 'cargadas')"
        />
        Usar capas cargadas
      </label>
      <label>
        <input
          type="radio"
          value="seleccionar"
          :checked="capas === 'seleccionar'"
          @change="$emit('update:capas', 'seleccionar')"
        />
        Seleccionar las capas
      </label>
    </fieldset>

    <div v-if="capas === 'seleccionar'" class="selection-controls">
       <button class="btn-select" @click="showLayerSelector = true">
         {{ capasSeleccionadas && capasSeleccionadas.length > 0 
            ? `${capasSeleccionadas.length} capas seleccionadas` 
            : 'Seleccionar capas' }}
       </button>
    </div>

    <!-- Modal de Selección de Capas -->
    <GeoprocesoSeleccionCapas
      v-if="showLayerSelector"
      :selectedLayers="capasSeleccionadas"
      @save="onSaveLayers"
      @close="showLayerSelector = false"
    />

    <fieldset>
      <legend>Seleccione método de cálculo a utilizar</legend>
      <label>
        <input
          type="radio"
          value="polygon"
          :checked="metodo === 'polygon'"
          @change="$emit('update:metodo', 'polygon')"
        />
        Usar población como Polígonos
      </label>
      <label>
        <input
          type="radio"
          value="point"
          :checked="metodo === 'point'"
          @change="$emit('update:metodo', 'point')"
        />
        Usar población como Puntos
      </label>
    </fieldset>
    
    <fieldset>
      <legend>Opciones avanzadas</legend>
      <label class="checkbox-label">
        <input
          type="checkbox"
          :checked="dissolve"
          @change="$emit('update:dissolve', $event.target.checked)"
        />
        Disolver geometrías (Dissolve)
      </label>
    </fieldset>
  </div>
</template>

<script>
import GeoprocesoSeleccionCapas from './GeoprocesoSeleccionCapas.vue';

export default {
  name: 'GeoprocesoOpcionesGenerales',
  components: { GeoprocesoSeleccionCapas },
  props: {
    capas: {
      type: String,
      required: true,
    },
    metodo: {
      type: String,
      required: true,
    },
    capasSeleccionadas: {
      type: Array,
      default: () => [],
    },
    dissolve: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showLayerSelector: false,
    };
  },
  watch: {
    capas(val) {
      if (val === 'seleccionar') {
        this.showLayerSelector = true;
      }
    },
  },
  methods: {
    onSaveLayers(selectedIds) {
      this.$emit('update:capasSeleccionadas', selectedIds);
      this.showLayerSelector = false;
    },
  },
};
</script>

<style scoped>
.selection-controls {
  margin-top: 5px;
  margin-bottom: 10px;
  margin-left: 20px;
}

.btn-select {
  background: #f0f0f0;
  border: 1px solid #ccc;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.btn-select:hover {
  background: #e0e0e0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: normal;
}

.checkbox-label input {
  margin: 0;
}
</style>
